import { useForm } from 'react-hook-form';
import { Button, Form, Space } from 'antd';
import { useStore } from '../../../helpers/use-store';
import { formEmailValidation, User } from '@monorepo/types';
import {
  FormInput,
  LoadingState,
  useLoading,
} from '@monorepo/react-components';
import { useNotification } from '../../../hooks/use-notification';
import { useTranslation } from 'react-i18next';

export const UserInfo = () => {
  const { t } = useTranslation();
  const { loadingState, updateLoadingState } = useLoading();
  const {
    dataStore: { userStore },
  } = useStore();
  const notificationApi = useNotification();

  const form = useForm<Pick<User, 'firstName' | 'lastName' | 'email'>>({
    defaultValues: {
      firstName: userStore.currentUser.firstName,
      lastName: userStore.currentUser.lastName,
      email: userStore.currentUser.email,
    },
  });

  const onSubmit = async (
    data: Pick<User, 'firstName' | 'lastName' | 'email'>
  ) => {
    try {
      updateLoadingState(LoadingState.Loading);

      await userStore.updateDetails(data);

      notificationApi.success({
        placement: 'top',
        message: t('common.success'),
        description: t('settings.profile.updateSuccess'),
      });
    } catch (e) {
      notificationApi.error({
        placement: 'top',
        icon: '',
        message: t('common.error'),
        description: t('settings.profile.updateError'),
      });
    } finally {
      updateLoadingState(LoadingState.Loaded);
    }
  };

  return (
    <Form layout="vertical" onFinish={form.handleSubmit(onSubmit)}>
      <Space size={'large'} direction="vertical" style={{ maxWidth: '450px' }}>
        <FormInput
          text={t('settings.profile.firstName')}
          form={form}
          controllerProps={{
            name: 'firstName',
            rules: { required: t('seriesForm.validation.nameRequired') },
          }}
        />

        <FormInput
          text={t('settings.profile.lastName')}
          form={form}
          controllerProps={{
            name: 'lastName',
            rules: { required: t('seriesForm.validation.nameRequired') },
          }}
        />

        <FormInput
          text={t('settings.profile.email')}
          form={form}
          controllerProps={{
            name: 'email',
            rules: formEmailValidation(),
          }}
        />

        <Form.Item>
          <Button
            disabled={!form.formState.isDirty}
            loading={loadingState === LoadingState.Loading}
            type="primary"
            htmlType="submit"
          >
            {t('settings.profile.saveButton')}
          </Button>
        </Form.Item>
      </Space>
    </Form>
  );
};
